import React, { useContext } from 'react';
import { ThemeContext } from '../../themes/campaignThemes';
import { StandingVideo } from 'shared/components';
import PropTypes from 'prop-types';
import {
	FullWidthColoredBackground,
	CampaignBlockContainer,
} from '../../pages/CampaignPage/CampaignPage.styles';
import {
	Layout1,
	Layout2,
	Layout3,
	TextMargin,
	TextWidth,
} from './CampaignStandingVideoBlock.styles';
import TextContent from './TextContent';

const CampaignStandingVideoBlock = ({
	Heading = '',
	Text = '',
	YoutubeShorts = [],
}) => {
	const theme = useContext(ThemeContext);

	const renderContent = () => {
		switch (YoutubeShorts.length) {
			case 1:
				return (
					<CampaignBlockContainer $theme={theme}>
						<Layout1>
							<TextContent
								Heading={Heading}
								Text={Text}
								theme={theme}
							/>
							<StandingVideo
								noPadding
								VideoLink={YoutubeShorts[0]}
							></StandingVideo>
						</Layout1>
					</CampaignBlockContainer>
				);

			case 2:
				return (
					<CampaignBlockContainer $extraWide $theme={theme}>
						<Layout2>
							<TextMargin>
								<TextContent
									Heading={Heading}
									Text={Text}
									theme={theme}
								/>
							</TextMargin>
							<StandingVideo
								noPadding
								VideoLink={YoutubeShorts[0]}
							/>
							<StandingVideo
								noPadding
								VideoLink={YoutubeShorts[1]}
							/>
						</Layout2>
					</CampaignBlockContainer>
				);

			case 3:
				return (
					<CampaignBlockContainer $extraWide $theme={theme}>
						<TextWidth>
							<TextContent
								Heading={Heading}
								Text={Text}
								theme={theme}
							/>
						</TextWidth>
						<Layout3>
							{YoutubeShorts.map((video, index) => (
								<StandingVideo
									key={index}
									noPadding
									VideoLink={video}
								/>
							))}
						</Layout3>
					</CampaignBlockContainer>
				);

			default:
				return null;
		}
	};

	return (
		<FullWidthColoredBackground $color={theme.color[1]}>
			{renderContent()}
		</FullWidthColoredBackground>
	);
};

export default CampaignStandingVideoBlock;

CampaignStandingVideoBlock.PropTypes = {
	Heading: PropTypes.string,
	Text: PropTypes.string,
	YoutubeShort1: PropTypes.string,
	YoutubeShort2: PropTypes.string,
	YoutubeShort3: PropTypes.string,
};
